module.exports = __webpack_public_path__ + "img/previous.6b254923.svg";